import * as THREE from "three";
import { gsap } from "gsap";

export const initGrinches = (experience) => {
  const animateGrinchIn = (grinch) => {
    if (!grinch) return;
    grinch.children[1].visible = false;

    gsap.to(grinch.position, {
      y: grinch.position.y + 1,
      duration: 0.6,
      ease: "sine.inOut",
    });

    gsap.to(grinch.scale, {
      x: 2,
      y: 2,
      z: 2,
      duration: 0.6,
      ease: "sine.inOut",

      onComplete: () => {
        animateGrinchEscape(grinch);
      },
    });

    // Play sound
    const audio = new Audio("/sounds/grinch-out.m4a");
    audio.play();

    // gsap.delayedCall(0.6, () => {
    // });
  };
  const animateGrinchOut = (grinch) => {
    if (!grinch) return;
    grinch.children[1].visible = false;

    if (grinch.escape) {
      grinch.escape.kill();
    }

    grinch.out = gsap.timeline();

    grinch.out.to(grinch.scale, {
      x: 0,
      y: 0,
      z: 0,
      duration: 0.1,
      ease: "sine.inOut",
    });

    grinch.out.eventCallback("onComplete", () => {
      grinch.position.copy(grinch.initialPosition);
      grinch.scale.copy(grinch.initialScale);
    });
  };

  const animateGrinchEscape = (grinch) => {
    if (!grinch) return;
    grinch.children[1].visible = true;

    grinch.escape = gsap.timeline();

    grinch.escape.to(grinch.position, {
      y: grinch.position.y + 4,
      duration: 1,
      ease: "linear",
    });

    grinch.escape.to(grinch.position, {
      y: grinch.position.y + 30,
      duration: 0.1,
      ease: "sin.inOut",
    });

    grinch.escape.to(
      grinch.scale,
      {
        x: 0,
        y: 0,
        z: 0,
        duration: 0.1,
        ease: "sin.inOut",
      },
      "-=0.1"
    );

    grinch.escape.delay(2);

    grinch.escape.eventCallback("onComplete", () => {
      grinch.position.copy(grinch.initialPosition);
      grinch.scale.copy(grinch.initialScale);
      experience.grinchesToDisplay.push(grinch);
      experience.updateEscaped();
    });
  };

  // add Burning animation
  const burningTexture = experience.textureLoader.load(
    "/grinch/burning_loop_2.png"
  );
  burningTexture.wrapS = THREE.RepeatWrapping;
  burningTexture.repeat.x = 1 / 8; // 8 frames in sprite sheet
  const burningMaterial = new THREE.MeshBasicMaterial({
    // color: 0xff0000,
    map: burningTexture,
    transparent: true,
    side: THREE.DoubleSide,
  });
  const burningPlane = new THREE.PlaneGeometry(1, 1);
  experience.grinches.forEach((grinch) => {
    // Animate frames
    const burningSprite = new THREE.Mesh(burningPlane, burningMaterial);

    function animateBurning() {
      const totalFrames = 8;
      let currentFrame = 0;

      setInterval(() => {
        burningTexture.offset.x = currentFrame / totalFrames;
        currentFrame = (currentFrame + 1) % totalFrames;
      }, 100); // Change frame every 100ms
    }

    animateBurning();
    burningSprite.position.y -= 1.5;
    burningSprite.scale.setScalar(2);
    // burningSprite.scale.y = 2;
    grinch.add(burningSprite);
  });

  if (!experience.isDebugMode) {
    experience.grinches.forEach((grinch) => {
      grinch.position.y -= 1;
      grinch.scale.setScalar(0.5);
      grinch.initialPosition = grinch.position.clone();
      grinch.initialScale = grinch.scale.clone();
      grinch.lookAt(experience.camera.position);
      experience.grinchesToDisplay.push(grinch);
    });
  }

  if (experience.isDebugMode) {
    experience.grinches.forEach((grinch) => {
      grinch.position.y += 4;
      grinch.scale.setScalar(2);
      grinch.initialPosition = grinch.position.clone();
      grinch.initialScale = grinch.scale.clone();
      grinch.lookAt(experience.camera.position);
    });
  }

  /**
   * Raycaster
   */
  const raycaster = new THREE.Raycaster();
  const pointer = new THREE.Vector2();

  function onPointerMove(event) {
    // calculate pointer position in normalized device coordinates
    // (-1 to +1) for both components
    raycaster.setFromCamera(pointer, experience.camera);

    pointer.x = (event.clientX / window.innerWidth) * 2 - 1;
    pointer.y = -(event.clientY / window.innerHeight) * 2 + 1;
  }
  window.addEventListener("pointermove", onPointerMove);

  function onClick(event) {
    // calculate objects intersecting the picking ray
    const intersects = raycaster.intersectObjects(experience.grinches);
    for (let i = 0; i < intersects.length; i++) {
      animateGrinchOut(intersects[i].object.parent);

      experience.grinchesToDisplay.push(intersects[i].object.parent);

      // Play sound
      const audio = new Audio("/sounds/ouch-02.m4a");
      audio.play();

      // Update score
      experience.updateCaught();
    }
  }
  window.addEventListener("click", onClick);

  let lastGrinchTime = 0;
  let nextGrinchInterval = Math.random() * 2000 + 1000; // Random time between 2ms and 5s

  experience.animateRandomGrinch = (currentTime) => {
    if (
      currentTime - lastGrinchTime > nextGrinchInterval &&
      !experience.isDebugMode
    ) {
      // Pick random Grinch
      const randomGrinch =
        experience.grinchesToDisplay[
          Math.floor(Math.random() * experience.grinchesToDisplay.length)
        ];

      // Animate the Grinch (example: pop-up animation)
      animateGrinchIn(randomGrinch);
      experience.grinchesToDisplay.splice(
        experience.grinchesToDisplay.indexOf(randomGrinch),
        1
      );

      // Reset timer and pick new interval
      lastGrinchTime = currentTime;
      nextGrinchInterval = Math.random() * 3000 + 2000;
    }
  };
};
